import {RouteTabParameter} from '../../types/common/RouteTabParameter';

export interface PeoplePaths {
  PeopleSearch: string,
}

export const peoplePaths: PeoplePaths = {
  PeopleSearch: '/advisor/people/search',
};